import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params, ParamMap } from '@angular/router';
import 'parse';
import { Moment } from 'moment';
import { Tchekb, HydratedTchek } from '../../model/tchekb.model';
import { TchekService, GetTchekOpts } from '../../service/tchek.service';
import { TchekOldService } from '../../service/tchek-old.service';
import { Folder } from '../../model/folder.model';
import { AwsService } from '../../service/aws.service';
import { SearchService } from '../../service/search.service';
import { environment } from '../../../environments/environment';
const parse: typeof Parse = require('parse');

@Component({
  selector: 'app-tchek-last-scan',
  templateUrl: './tchek-last-scan.component.html',
  styleUrls: ['./tchek-last-scan.component.less']
})
export class TchekLastScanComponent implements OnInit {
  moment = require('moment/moment');

  getTchekOptions = {
    includeThumbnail: true,
    sort: 'latest'
  } as GetTchekOpts;

  cameraList = [1, 3, 5, 8, 10, 12];
  cameravideo = [];
  tchekCreatedAt: string;
  immat: string;
  tchek: HydratedTchek;

  constructor(
    private readonly _routerService: Router,
    private readonly _tchekService: TchekService,
    private readonly _tchekOldService: TchekOldService,
    private readonly _awsService: AwsService
  ) { this.moment.locale('fr') }

  openplayer(camera: number) {
    console.log("open player");
    this._routerService
      .navigate(['player', this.tchek.id, camera, 0], { queryParams: { isPercent: false } })
  }

  tchekAddedObserver(tchek: HydratedTchek) {
    this.cameravideo = [];
    this.tchek = tchek;
    const cpPromises = [];
    this.tchekCreatedAt = this.moment(this.tchek.tchekCreatedAt).format("dddd D MMMM YYYY HH:mm:ss");
    this._tchekService.get(this.tchek.id).then(tchek => { this.immat = tchek.vehiclePtr.immat });
    let i = 0
    let folder = this.tchek.thumbnailUrl.split('/')
    this.cameraList.forEach(cameraNumber => {
      if (environment.isLocal)
        cpPromises[i] = this._awsService.generateUrlPromise(`${this.tchek.devicePtr.webObjectId}/${folder[1]}/${cameraNumber}/moyen.mp4`, this.tchek.devicePtr.ipMachine);
      else
        cpPromises[i] = this._awsService.generateUrlPromise(`${this.tchek.devicePtr.id}/${folder[1]}/${cameraNumber}/moyen.mp4`, this.tchek.devicePtr.ipMachine);
      i++
    });
    Promise.all(cpPromises).then(resolvedPromises => {
      resolvedPromises.forEach(link => {
        this.cameravideo.push(link)
      });
    })
    console.log("scan new", tchek);
  }

  tchekRemovedObserver(tchek: HydratedTchek) {
    if (this.tchek && this.tchek.id === tchek.id) {
      this.tchek = undefined
      this.tchekCreatedAt = undefined;
      this.immat = undefined;
      this.cameravideo = [];
      this._tchekService.getAll(this.getTchekOptionsFirst).then(result => { this.tchekAddedObserver(result[0]) })
    }
    console.log("scan remove", tchek);
  }

  getTchekOptionsFirst = {
    limit: 1,
    includeThumbnail: true,
    sort: 'latest'
  } as GetTchekOpts;

  ngOnInit() {
    const observablesPair = this._tchekService.subscribeTcheks(this.getTchekOptions);
    observablesPair.plusOneObservable.subscribe(this.tchekAddedObserver.bind(this));
    observablesPair.minusOneObservable.subscribe(this.tchekRemovedObserver.bind(this));
    observablesPair.changedObservable.subscribe(this.tchekAddedObserver.bind(this));

    if (!this.tchek)
      this._tchekService.getAll(this.getTchekOptionsFirst).then(result => { this.tchekAddedObserver(result[0]) })
  }
}



// WEBPACK FOOTER //
// ./src/app/element/tchek-last-scan/tchek-last-scan.component.ts